import { find, toInteger } from "lodash";

// code uses ISO 639-1
export const languages = [
  { code: "en", enName: "English", nativeName: "" },
  { code: "tl", enName: "Tagalog", nativeName: "Wikang Tagalog" },
  { code: "vi", enName: "Vietnamese", nativeName: "Tiếng Việt" },
  { code: "zh", enName: "Chinese", nativeName: "中文" },
  { code: "es", enName: "Spanish", nativeName: "Español" },
  { code: "ar", enName: "Arabic", nativeName: "العربية" },
  { code: "fa", enName: "Farsi", nativeName: "فارسی" },
];

export const getLanguageNameByCode = (code: string): string | null => {
  const lang = find(languages, (x) => x.code === code);
  return lang ? lang.enName : null;
};

export const formatAsCurrency = (number: string): string => {
  const formatter = new Intl.NumberFormat("us-US", { style: "currency", currency: "USD", maximumSignificantDigits: 3 });
  return formatter.format(toInteger(number));
};
